var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13718_67925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12H4V18H18V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20H4V22H8V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20H9V22H13V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20H14V22H18V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 23H4V25H8V23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 23H9V25H13V23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 23H14V25H18V23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 26H4V28H8V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 26H9V28H13V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 26H14V28H18V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4H18V1C18 0.45 17.55 0 17 0H5C4.45 0 4 0.45 4 1V4H3C1.35 4 0 5.35 0 7V30C0 31.65 1.35 33 3 33H19C20.65 33 22 31.65 22 30V7C22 5.35 20.65 4 19 4ZM5 1H17V8H5V1ZM20 30C20 30.55 19.55 31 19 31H3C2.45 31 2 30.55 2 30V7C2 6.45 2.45 6 3 6H4V8C4 8.55 4.45 9 5 9H17C17.55 9 18 8.55 18 8V6H19C19.55 6 20 6.45 20 7V30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13718_67925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.3c3932b1892d2eba0f0c5f5538ffa76f.svg";
export { ForwardRef as ReactComponent };